export const toolbarWithColors = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", { color: ["#dd8c55", "#017f49"] }, "link"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["clean"],
];
